<template>
  <v-data-table
    :headers="headers"
    mobile-breakpoint="0"
    :items-per-page="5"
    sort-by="name"
    :items="items"
    item-key="id"
    loading-text="Đang Tải"
    disable-sort
    :loading="loading"
    @update:options="optionsChange"
    :server-items-length="count"
    no-data-text="Không tìm thấy dữ liệu"
  >
    <template v-slot:[`item.student`]="{ item }">
      <CardStudentName v-if="item.student" :student="item.student" />
    </template>
    <template v-slot:[`item.createdAt`]="{ item }">
      {{ item.createdAt | formatDateTime }}
    </template>
    <template v-slot:[`item.createdBy`]="{ item }">
      {{ get(item, 'createdBy.name', '') }}
    </template>
    <template v-slot:[`item.usedCredit`]="{ item }">
      <span class="green--text"> +{{ get(item, 'usedCredit', 0).toLocaleString('en-US') }} </span>
    </template>
  </v-data-table>
</template>

<script>
import CardStudentName from '@/components/basic/card/CardStudentName'
import { mapActions, mapMutations, mapState } from 'vuex'
import { get } from 'lodash'
export default {
  components: {
    CardStudentName,
  },
  data() {
    return {
      headers: [
        { text: 'Học sinh', value: 'student' },
        { text: 'Thời gian', value: 'createdAt' },
        { text: 'Người nạp', value: 'createdBy' },
        { text: 'Số tiền', value: 'usedCredit', align: 'end' },
      ],
      get,
    }
  },

  computed: {
    ...mapState({
      items: state => state.studentCreditUsage.creditUsages,
      count: state => state.studentCreditUsage.count,
      query: state => state.studentCreditUsage.query,
      loading: state => state.studentCreditUsage.loading,
    }),
  },
  mounted() {
    this.fetchItems({ type: 'in' })
  },
  methods: {
    ...mapActions({ fetchItems: 'studentCreditUsage/fetch', countItems: 'studentCreditUsage/countItems' }),
    ...mapMutations({
      setLoading: 'studentCreditUsage/setLoading',
    }),
    async optionsChange(option) {
      try {
        this.setLoading(true)
        await this.fetchItems({
          ...this.query,
          type: 'in',
          _start: (option.page - 1) * option.itemsPerPage,
          _limit: option.itemsPerPage,
        })
      } catch (error) {
      } finally {
        this.setLoading(false)
      }
    },
  },
}
</script>

<style></style>
